<div class="settings-wrapper">
    <div class="flex justify-between items-center w-full">
        <div class="flex items-center justify-start settings-header" style="gap: 13px;">
            <app-searchbar style="max-width: 620px; width: 620px;" placeholder="Buscar"></app-searchbar>
        </div>
        <app-welcome-user></app-welcome-user>
    </div>
    <div class="content-wrapper min-h-[714px]" *ngIf="!showDetails">
        <div class="flex justify-between w-full px-9">

            <p class="title mb-4">Grupos</p>
            <app-accent-button class="h-10" text="Crear grupo" icon="fa-light fa-circle-plus mr-2" [selected]="true"
                (click)="createGroup()"></app-accent-button>
        </div>

        <div class="buttons-bar w-full"></div>

        <div *ngFor="let group of groups">

            <div
                class="flex justify-between items-center mx-9 mt-6 bg-quaternary h-14 rounded-button px-6 border border-tertiary">
                <p class="text-white">{{group.name}}</p>
                <div class="flex items-center">
                    <span
                        class="text-white bg-dateBlueButton border border-accent rounded-container mr-10 py-2 w-[188px] text-center h-9"
                        *ngIf="group.id_configuration_profile">{{group.profile.name}}</span>
                    <span
                        class="text-white bg-modalBlue border border-accent rounded-container mr-10 py-2 w-[188px] text-center h-9"
                        *ngIf="!group.id_configuration_profile"><i class="fa-light fa-sliders mr-2"></i>Personalizado</span>
                        <span class="pl-10 text-white hover:text-grey cursor-pointer" (click)="openDetails(group)">
                            Detalles
                            <i class="fal fa-eye" style="margin-left: 10px;"></i>
                        </span>
                </div>
            </div>
        </div>


        <!-- <div *ngIf="loading" class="loading-wrapper">
            <mat-spinner></mat-spinner>
            <p>Cargando...</p>
        </div> -->

    </div>
    <app-group-details *ngIf="showDetails" [deatails]="showDetails" [group]="selectedGroup"
        (changeDetails)="changeDetails($event)"></app-group-details>
</div>